import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import allActions from "../../../state/actions";
import InfoTooltipElement from "../../shared/infoTooltipElement/InfoTooltipElement";
import SelectField from "../../shared/selectField/SelectField";
import FileUploader from "../../shared/fileUploader/FileUploader";
import ModalConfirm from "../../shared/modalConfirm/ModalConfirm";
import CustomButton from "../../shared/customButton/CustomButton";
import CampiMetriQuadri from "../campiMetriQuadri/CampiMetriQuadri";
import MessaggioPersonalizzazione from "../messaggioPersonalizzazione/MessaggioPersonalizzazione";
import DropdownColore from "../dropdownColore/DropdownColore";
import ProductKit from "../productKit/ProductKit";
import TotaleCostoProdotto from "../totaleCostoProdotto/TotaleCostoProdotto";
import PulsanteAggiungiCarrello from "../pulsanteAggiungiCarrello/PulsanteAggiungiCarrello";
import ModalAddedToCart from "../modalAddedToCart/ModalAddedToCart";
import ProductKitModal from "../productKitModal/ProductKitModal";
import { axios } from "../../../utils/axiosBase";
import { gtmAddToCart } from "../../../gtm/gtm";
//import { fbqAddToCart } from "../../../fbq/fbq";

const ProductConfigurationLogoPersonalizzato = ({
  selectedFile,
  savedFile,
  orientamento,
  setSelectedFile,
  setSavedFile,
  setOrientamento,
}) => {
  // store data
  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector((state) => state.user.token_id);
  const cartLastItem = useSelector((state) => state.cartLastItem);
  const order = useSelector((state) => state.order);
  const user = useSelector((state) => state.user);
  const currentLang = useSelector((state) => state.currentPage.currentLang);
  const siteParams = useSelector((state) => state.siteParams);
  const pageContent = useSelector((state) => state.currentPage.pageContent);
  const promotion = useSelector((state) => state.promotion);
  const area_stampa = useSelector(
    (state) => state.currentPage.pageContent.detail.flags?.area_stampa
  );
  const superficie_logo = useSelector(
    (state) => state.currentPage.pageContent.detail.flags?.superficie_logo
  );
  const productformati = useSelector(
    (state) => state.currentPage.pageContent.detail.flags?.productformati
  );

  const fasiCarrelloTranslation = useSelector(
    (state) => state.translations.fasiCarrello
  );
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );
  const flags = useSelector(
    (state) => state.currentPage.pageContent.detail.flags
  );

  const productId = useSelector((state) => state.currentPage.pageContent.id);

  const [name, setName] = useState("");

  const onOrientamentiChange = (event) => {
    console.log(event.target.value);
    if (event.value === undefined) {
      setOrientamento(event.target.value);
    } else {
      setOrientamento(event.value);
    }
  };

  const onPreviewLogoClick = async (event) => {
    event.preventDefault();
    console.log(savedFile);

    const payload = {
      savedFile: savedFile,
      productId: productId,
      orientamento: orientamento,
    };

    // chiamo web service
    const response = await axios.post(
      `api/previewlogopersonalizzato/`,
      payload,
      {
        withCredentials: true,
      }
    );

    if (response.data.errors === "") {
      ModalConfirm({
        titleToShow: "",
        messageToShow: response.data.html,
        isShowConfirmButton: false,
        isShowCanceButton: false,
        isShowCloseButton: true,
        isTimerModal: false,
        textConfirmButton: genericheTranslation.conferma.itemName,
        textCancelButton: genericheTranslation.annulla.itemName,
        customClassContainer: `modalExitIntentRibola ${orientamento}`,
      });
    } else {
      ModalConfirm({
        titleToShow: "",
        messageToShow: response.data.errors,
        isShowConfirmButton: false,
        isShowCanceButton: false,
        isShowCloseButton: true,
        isTimerModal: false,
        textConfirmButton: genericheTranslation.conferma.itemName,
        textCancelButton: genericheTranslation.annulla.itemName,
        customClassContainer: "modalExitIntentRibola",
      });
    }
  };

  // menu a tendina di orientamenti?
  let elencoOrientamenti = [];

  elencoOrientamenti[0] = {
    id: "orizzontale",
    value: genericheTranslation.orientamentolandscape.itemName.toUpperCase(),
  };
  elencoOrientamenti[1] = {
    id: "verticale",
    value: genericheTranslation.orientamentoportrait.itemName.toUpperCase(),
  };

  let areaStampa;
  let superficieLogo;
  let productFormati;
  if (area_stampa) {
    areaStampa = area_stampa;
  }
  if (superficie_logo) {
    superficieLogo = superficie_logo;
  }
  if (productformati) {
    productFormati = productformati;
  }

  const onRecoverPasswordClick = (event) => {
    event.preventDefault();
  };
  const divTendinaOrientamenti =
    elencoOrientamenti.length !== 0 ? (
      <div className="grid grid-cols-60 mt-1 mb-3">
        <div className="col-span-60">
          <SelectField
            showLabel={false}
            selectName="orientamenti"
            selectListValue={elencoOrientamenti}
            selectLabel={genericheTranslation.scegliopzione.itemName.toUpperCase()}
            selectHandlerFunction={onOrientamentiChange}
            selectLabelStyle="text-sm"
            selectClassStyle="bg-transparent w-full border border-ribola-dove-gray border-opacity-20 focus:border-opacity-100 py-1.5 mt-px text-sm"
          />
        </div>
      </div>
    ) : (
      ""
    );

  const fileFormatForPreview = ".jpg;.png";
  //const fileFormatForPreview = "";
  const btnPreview =
    fileFormatForPreview
      .split(";")
      .includes("." + selectedFile?.name.split(".").pop().toLowerCase()) &&
    selectedFile?.length !== 0 &&
    selectedFile !== null &&
    orientamento !== "" ? (
      <div className="grid grid-cols-60 mt-1 mb-5">
        <div className="col-span-60">
          <CustomButton
            buttonId="buttonpreviewlogo"
            buttonLink={null}
            buttonOnClickFunction={(event) => onPreviewLogoClick(event)}
            buttonName={genericheTranslation.buttonpreviewlogo.itemName.toUpperCase()}
            buttonStyle="w-auto flex justify-center items-center text-white bg-ribola-astral hover:bg-ribola-congress-blue transition duration-300 text-lg 2xl:text-xl font-opensanssemibold py-3 px-6"
          />
        </div>
      </div>
    ) : (
      ""
    );

  const titoloOrientamenti = (
    <div className="w-100">
      {genericheTranslation.selezionaorientamenti.itemName.toUpperCase()}
    </div>
  );

  const messaggioPersonalizzazione = (
    <div className="py-2">
      <MessaggioPersonalizzazione
        areaStampa={areaStampa}
        superficieLogo={superficieLogo}
        productFormati={productFormati}
      />
    </div>
  );

  const arrayProductFormati = productFormati.split(";");

  const fileUpload = (
    <>
      <input
        autoComplete="on"
        type="hidden"
        name="logopreviewfile"
        value={savedFile}
      />
      <FileUploader
        fileFormat={arrayProductFormati}
        onFileSelectSuccess={async (file) => {
          setSelectedFile(file);
          const formData = new FormData();
          formData.append("data", file);
          const response = await axios.post(
            `api/storefilepersonalizzati/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              withCredentials: true,
            }
          );

          if (response.data.status !== "OK") {
            // mostro il pulsante per la preview
            /*return Swal.showValidationMessage(
              `${genericheTranslation.richiestafallita.itemName} ${response.data.error}`
            );*/
          } else {
            setSavedFile(response.data.pathfile);
            return response.data;
          }
        }}
        onFileSelectError={({ error }) =>
          ModalConfirm({
            titleToShow: genericheTranslation.modalattenzionetitle.itemName,
            messageToShow: error,
            isShowCanceButton: false,
            isShowConfirmButton: false,
            isShowCloseButton: true,
            isTimerModal: true,
            textConfirmButton: genericheTranslation.conferma.itemName,
            textCancelButton: genericheTranslation.annulla.itemName,
          })
        }
      />
    </>
  );

  // local state

  const [refreshCampi, setRefreshCampi] = useState(1);

  useEffect(() => {
    console.log("ProductConfigurationLogoPersonalizzato");
    console.log(savedFile);
  }, [orientamento, cartLastItem, order, selectedFile, savedFile]);

  return (
    <div>
      <span className="text-xl font-opensanssemibold flex justify-between flex-col">
        {messaggioPersonalizzazione}
        {fileUpload}
        {titoloOrientamenti}
        {divTendinaOrientamenti}
        {btnPreview}
      </span>
    </div>
  );
};

export default ProductConfigurationLogoPersonalizzato;
